"use client";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { FaCheckCircle, FaPlus } from "react-icons/fa";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  OutlinedInput,
  FormControl,
  Typography,
  useTheme,
  CircularProgress,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { MdSave, MdCancel } from "react-icons/md";
// import Select from "react-select";
import LoadingBackdrop from "../components/LoadingBackdrop";

import TextareaAutosize from "@mui/material/TextareaAutosize";
// import {BUSINESS_TYPES_SELECT} from "@/app/constants/businessTypes";
import { getCustomTableDialogueStyles } from "../constants/tableDialougeStyles";
import MRTDatatable from "../components/MRTDatatable";
import { IoIosCloseCircle } from "react-icons/io";
import ImageUpload from "../../components/ImageUpload";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import REQUEST_SERVICE from "../../api/request";
// import Notifications from "@/app/helpers/notifications";

const columns = [
  {
    accessorKey: "fname",
    header: "First Name",
  },
  {
    accessorKey: "lname",
    header: "Last Name",
  },
  {
    accessorKey: "email",
    header: "Email",
  },
  {
    accessorKey: "interest",
    header: "Interest",
  },
  {
    accessorKey: "position",
    header: "Position",
  },
];

export default function Content() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [isMounted, setIsMounted] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    interest: "",
    position: "",
  });

  const handleOpen = () => {
    setIsEditMode(false);
    setEditingId(null);
    setFormData({
      "fname": "",
      "lname": "",
      "email": "",
      "interest": "",
      "position": "",
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setIsEditMode(false);
    setEditingId(null);
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSelectChange = (value, action) => {
    setFormData(prev => ({
      ...prev,
      [action.name]: value,
    }));
  };

  const handleInformationChange = (value) => {
    setFormData(prev => ({
      ...prev,
      information: value,
    }));
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      // Process images - first image goes to 'image' field, rest go to 'images' array
      if (formData.images && formData.images.length > 0) {
        formData.image = formData.images[0]; // First image as main image
      } else if (formData.image && !formData.images.length) {
        formData.images = [formData.image]; // Single image in array
      }

      if (isEditMode) {
        let data = {
            ...formData,
        }
        const res = await REQUEST_SERVICE.update(editingId, data)
        if (res.status === 200) {
            // await Notifications.successMsg(res?.message)
            await getTableData()
            handleClose()
        } else {
            // await Notifications.errorMsg(res?.message?.user)
        }
      } else {
        let data = {
          ...formData,
        };
        const res = await REQUEST_SERVICE.create(data);

        console.log(res);
        if (res.status === 200) {
          // await Notifications.successMsg(res?.message)
          await getTableData();
          handleClose();
        } else {
          // await Notifications.errorMsg(res?.message?.user)
        }
      }
    } catch (error) {
      console.error('Save error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = tableMeta => {
    // Handle both single image and multiple images
    const images = Array.isArray(tableMeta?.images) ? tableMeta.images : 
                  tableMeta?.image ? [tableMeta.image] : [];
    
    setFormData({
      fname: tableMeta?.fname,
      lname: tableMeta?.lname,
      email: tableMeta?.email,
      interest: tableMeta?.interest,
      position: tableMeta?.position,
    })

    setIsEditMode(true)
    setEditingId(tableMeta?._id)
    setOpen(true)
  };

  const handleDelete = async tableMeta => {
    setIsDeleting(true)
    try {
        const res = await REQUEST_SERVICE.destroy(tableMeta?._id)
        if (res.status === 200) {
            // await Notifications.successMsg(res?.message)
            await getTableData()
        } else {
            // await Notifications.errorMsg(res?.message?.user)
        }
    } catch (error) {

    } finally {
        setIsDeleting(false)
    }
  };

  async function getTableData() {
    const res = await REQUEST_SERVICE.all();
    if (res.status === 200) {
      setTableData(res?.data);
    }
  }

  useEffect(() => {
    setIsMounted(true);
    getTableData()
  }, []);

  // Auto-calculate discount when price or originalPrice changes
  // useEffect(() => {
  //     const {price, originalPrice} = formData;
  //     if (price && originalPrice && !isNaN(price) && !isNaN(originalPrice) && parseFloat(originalPrice) > 0) {
  //         const priceNum = parseFloat(price);
  //         const originalPriceNum = parseFloat(originalPrice);
  //         const discountPercentage = ((originalPriceNum - priceNum) / originalPriceNum * 100).toFixed(0);
  //
  //         // Only update if the calculated discount is different from current
  //         if (parseFloat(discountPercentage) !== parseFloat(formData.discount)) {
  //             setFormData(prev => ({
  //                 ...prev,
  //                 discount: discountPercentage
  //             }));
  //         }
  //     } else if (!price || !originalPrice) {
  //         // Clear discount if either price field is empty
  //         if (formData.discount !== "") {
  //             setFormData(prev => ({
  //                 ...prev,
  //                 discount: ""
  //             }));
  //         }
  //     }
  // }, [formData.price, formData.originalPrice]);

  return (
    <Box sx={{ width: "100%" }}>
      <LoadingBackdrop
        open={isDeleting}
        message="Deleting Record"
      />

      {isMounted && (
        <>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FaPlus style={{ fontSize: "10px" }} />}
              onClick={handleOpen}
              size="small"
            >
              Create
            </Button>
          </Box>
          <MRTDatatable
            title="Product Offers"
            columns={columns}
            data={tableData}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{isEditMode ? "Edit Request" : "Create Request"}</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "1fr 1fr",
              },
              gap: 2,
              mt: 2,
            }}
          >
            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                First Name
              </Typography>
              <OutlinedInput
                name="fname"
                value={formData.fname}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>
            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Last Name
              </Typography>
              <OutlinedInput
                name="lname"
                value={formData.lname}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>
            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Email
              </Typography>
              <OutlinedInput
                name="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>
            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Interest
              </Typography>
              <OutlinedInput
                name="interest"
                value={formData.interest}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>
            <FormControl fullWidth>
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Position
              </Typography>
              <OutlinedInput
                name="position"
                value={formData.position}
                onChange={handleChange}
                fullWidth
              />
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            startIcon={<MdCancel />}
            color="error"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            startIcon={isLoading ? <CircularProgress size={16} /> : <MdSave />}
            color="primary"
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : isEditMode ? "Update" : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
